export default function customURLConverter(url, node, on_save, name) {
	// Note: duplicates in derkontext.js and kontextlab.js
	// An in-page anchor — a map deeplink is one — must stay as written: resolving
	// it would prepend the current page's path and break the link.
	if (url.startsWith('#')) {
		return url;
	}
	const l = document.createElement('a');
	// Set link and remove relative path part before the browser converts
	// the relative part.
	l.href = url.replace(/^(\.\.\/)+/, '/');
	if (window.location.host !== l.host) {
		return url;
	}
	// Replace duplicates for /client
	const path = l.pathname.replace(/^(\/client){2,}/, '/client');
	// Create an absolute path without hostname
	return path + l.search + l.hash;
}
